import { UnstyledListWithIconAdapter as UnstyledListWithIcon } from "./UnstyledListWithIcon";

export { UnstyledListWithIcon };
